import { PrimaryButton, Stack, useTheme } from '@fluentui/react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { EventPriceTypeEnum } from '../../../Models/Event/EventPriceTypeEnum';
import { IEventItem } from '../../../Models/Event/IEventItem';

interface IPriceInfoProps {
    event: IEventItem,
}

export const PriceInfo: React.FunctionComponent<IPriceInfoProps> = (props) => {
    const renderPrice = (item: IEventItem) => {
        return (<Stack horizontal styles={{ root: { paddingTop:10 } }}>
            {item && item.priceType === EventPriceTypeEnum.ByEvent ?
                <span>Cena: {item.price},- Kč</span>
                : null}
            {item && item.priceType === EventPriceTypeEnum.BySemester ?
                <div>
                    {item.firstSemesterPrice == item.secondSemesterPrice ?
                        <span>Pololetí: {item.firstSemesterPrice},- Kč</span>
                        :
                        <Stack horizontalAlign="end" tokens={{ childrenGap: 0 }}>
                            <span>1 pololetí: {item.firstSemesterPrice},- Kč</span>
                            <span>2 pololetí: {item.secondSemesterPrice},- Kč</span>
                        </Stack>
                    }
                </div>
                : null}

        </Stack>)
    }

    return (renderPrice(props.event))
}
